import type {LoggedInUserDataWithToken} from '@aboutyou/user';
import {createContext} from 'react';
import type {AuthenticationContexts} from './AuthenticationContexts';

export interface AuthenticationProps {
  context: AuthenticationContexts;
  /**
   * Called regardless of action type, runs whenever the user successfully exists the auth prompt
   */
  onSuccess?: (customer: LoggedInUserDataWithToken) => void;
  /**
   * Called if an error is thrown during the authentication process
   */
  onError?: (error: string) => void;
  /**
   * Called if the user cancels the auth process e.g. closes the modal
   */
  onCancel?: VoidFunction;
  /**
   * If true, the modal will display the guest option
   */
  allowGuestLogin?: boolean;
  /**
   * If provided, it will replace the current history entry when the modal opens
   * If not, a new entry will be added
   */
  replaceHistory?: boolean;
  /**
   * If provided, it will display login screen with the provided component at the top below the header
   */
  customBannerComponent?: React.ReactNode;
  /**
   * If provided, it will display login screen with the provided component at the top below the header
   */
  aboveHeaderBannerComponent?: React.ReactNode;
  /**
   * Disable toast shown on success. There are some situations where we dont want to show toast. Mainly mobile implementations of features
   */
  disableSuccessToast?: boolean;
  /**
   * redirect to checkout if apple login
   */
  forceRedirectToCheckoutOnSSOLoginSuccess?: boolean;
  /**
   * Force relogin modal in situations where user is logged in but session expired
   */
  forceSessionRefresh?: boolean;
  /**
   * needs CO Session to continue further
   */
  needsCheckoutSession: boolean;
}

export interface AuthenticationConfig {
  showUserAuthenticationPrompt: (props: AuthenticationProps) => void;
}

export const AuthenticationContext = createContext<AuthenticationConfig>(
  {} as AuthenticationConfig,
);
